(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-html.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-html.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'WalletKit-web'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'WalletKit-web'.");
    }
    if (typeof globalThis['kotlinx-html'] === 'undefined') {
      throw new Error("Error loading module 'WalletKit-web'. Its dependency 'kotlinx-html' was not found. Please, check whether 'kotlinx-html' is loaded prior to 'WalletKit-web'.");
    }
    globalThis['WalletKit-web'] = factory(typeof globalThis['WalletKit-web'] === 'undefined' ? {} : globalThis['WalletKit-web'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-html']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_html) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.ba;
  var getStringHashCode = kotlin_kotlin.$_$.c9;
  var initMetadataForClass = kotlin_kotlin.$_$.e9;
  var VOID = kotlin_kotlin.$_$.b;
  var append = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.k;
  var Unit_instance = kotlin_kotlin.$_$.p2;
  var fromInt = kotlin_kotlin.$_$.z7;
  var divide = kotlin_kotlin.$_$.x7;
  var negate = kotlin_kotlin.$_$.f8;
  var Long = kotlin_kotlin.$_$.pc;
  var compare = kotlin_kotlin.$_$.t7;
  var modulo = kotlin_kotlin.$_$.d8;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.d;
  var padStart = kotlin_kotlin.$_$.db;
  var THROW_CCE = kotlin_kotlin.$_$.tc;
  var toDoubleOrNull = kotlin_kotlin.$_$.sb;
  var numberToLong = kotlin_kotlin.$_$.g8;
  var attributesMapOf = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.p1;
  var H2 = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.v;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.r3;
  var DIV = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.s;
  var LABEL = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.a1;
  var SELECT = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.f1;
  var OPTION = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.d1;
  var InputType_number_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.g;
  var enumEncode = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.j;
  var attributesMapOf_0 = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.o1;
  var INPUT = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.z;
  var BUTTON = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.r;
  var ButtonType_button_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.a;
  var set_onClickFunction = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.m;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(WalletLabels, 'WalletLabels');
  initMetadataForClass(TopUpPaymentMethodOption, 'TopUpPaymentMethodOption');
  initMetadataForClass(WalletClassNames, 'WalletClassNames', WalletClassNames);
  //endregion
  function WalletLabels(walletHeading, topupCardLabel, topupAmountLabel, topupButton, loadErrorMessage) {
    this.e24_1 = walletHeading;
    this.f24_1 = topupCardLabel;
    this.g24_1 = topupAmountLabel;
    this.h24_1 = topupButton;
    this.i24_1 = loadErrorMessage;
  }
  protoOf(WalletLabels).toString = function () {
    return 'WalletLabels(walletHeading=' + this.e24_1 + ', topupCardLabel=' + this.f24_1 + ', topupAmountLabel=' + this.g24_1 + ', topupButton=' + this.h24_1 + ', loadErrorMessage=' + this.i24_1 + ')';
  };
  protoOf(WalletLabels).hashCode = function () {
    var result = getStringHashCode(this.e24_1);
    result = imul(result, 31) + getStringHashCode(this.f24_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g24_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h24_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i24_1) | 0;
    return result;
  };
  protoOf(WalletLabels).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WalletLabels))
      return false;
    if (!(this.e24_1 === other.e24_1))
      return false;
    if (!(this.f24_1 === other.f24_1))
      return false;
    if (!(this.g24_1 === other.g24_1))
      return false;
    if (!(this.h24_1 === other.h24_1))
      return false;
    if (!(this.i24_1 === other.i24_1))
      return false;
    return true;
  };
  function renderWallet(container, wallet, paymentMethodOptions, labels, onTopUp, classNames) {
    classNames = classNames === VOID ? new WalletClassNames() : classNames;
    container.innerHTML = '';
    append(container, renderWallet$lambda(classNames, labels, wallet, paymentMethodOptions, container, onTopUp));
  }
  function TopUpPaymentMethodOption(ref, label) {
    this.j24_1 = ref;
    this.k24_1 = label;
  }
  protoOf(TopUpPaymentMethodOption).toString = function () {
    return 'TopUpPaymentMethodOption(ref=' + this.j24_1 + ', label=' + this.k24_1 + ')';
  };
  protoOf(TopUpPaymentMethodOption).hashCode = function () {
    var result = getStringHashCode(this.j24_1);
    result = imul(result, 31) + getStringHashCode(this.k24_1) | 0;
    return result;
  };
  protoOf(TopUpPaymentMethodOption).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TopUpPaymentMethodOption))
      return false;
    if (!(this.j24_1 === other.j24_1))
      return false;
    if (!(this.k24_1 === other.k24_1))
      return false;
    return true;
  };
  function WalletClassNames(heading, balance, form, label, select, input, button) {
    heading = heading === VOID ? 'walletkit-heading' : heading;
    balance = balance === VOID ? 'walletkit-balance' : balance;
    form = form === VOID ? 'walletkit-form' : form;
    label = label === VOID ? 'walletkit-label' : label;
    select = select === VOID ? 'walletkit-select' : select;
    input = input === VOID ? 'walletkit-input' : input;
    button = button === VOID ? 'walletkit-button' : button;
    this.l24_1 = heading;
    this.m24_1 = balance;
    this.n24_1 = form;
    this.o24_1 = label;
    this.p24_1 = select;
    this.q24_1 = input;
    this.r24_1 = button;
  }
  protoOf(WalletClassNames).toString = function () {
    return 'WalletClassNames(heading=' + this.l24_1 + ', balance=' + this.m24_1 + ', form=' + this.n24_1 + ', label=' + this.o24_1 + ', select=' + this.p24_1 + ', input=' + this.q24_1 + ', button=' + this.r24_1 + ')';
  };
  protoOf(WalletClassNames).hashCode = function () {
    var result = getStringHashCode(this.l24_1);
    result = imul(result, 31) + getStringHashCode(this.m24_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n24_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o24_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p24_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q24_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r24_1) | 0;
    return result;
  };
  protoOf(WalletClassNames).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WalletClassNames))
      return false;
    if (!(this.l24_1 === other.l24_1))
      return false;
    if (!(this.m24_1 === other.m24_1))
      return false;
    if (!(this.n24_1 === other.n24_1))
      return false;
    if (!(this.o24_1 === other.o24_1))
      return false;
    if (!(this.p24_1 === other.p24_1))
      return false;
    if (!(this.q24_1 === other.q24_1))
      return false;
    if (!(this.r24_1 === other.r24_1))
      return false;
    return true;
  };
  function formatBalance(cents) {
    // Inline function 'kotlin.Long.div' call
    var whole = divide(cents, fromInt(100));
    // Inline function 'kotlin.Long.rem' call
    var this_0 = compare(cents, new Long(0, 0)) < 0 ? negate(cents) : cents;
    var fraction = modulo(this_0, fromInt(100));
    return whole.toString() + '.' + padStart(fraction.toString(), 2, _Char___init__impl__6a9atx(48));
  }
  function renderWallet$lambda$lambda($container, $classNames, $onTopUp) {
    return function (it) {
      var tmp = $container.querySelector('.' + $classNames.p24_1);
      var methodSelect = tmp instanceof HTMLSelectElement ? tmp : THROW_CCE();
      var tmp_0 = $container.querySelector('.' + $classNames.q24_1);
      var amountInput = tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE();
      var tmp0_elvis_lhs = toDoubleOrNull(amountInput.value);
      var amountCents = numberToLong((tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) * 100);
      $onTopUp(methodSelect.value, amountCents);
      return Unit_instance;
    };
  }
  function renderWallet$lambda($classNames, $labels, $wallet, $paymentMethodOptions, $container, $onTopUp) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.h2' call
      var classes = $classNames.l24_1;
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new H2(attributesMapOf('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f($labels.e24_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      // Inline function 'kotlinx.html.div' call
      var classes_0 = $classNames.m24_1;
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_1 = new DIV(attributesMapOf('class', classes_0), $this$append);
      if (!(this_1.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_1.j1f().a1h(this_1);
      this_1.n1f(!($wallet == null) ? formatBalance($wallet.z23_1) + ' ' + $wallet.y23_1 : $labels.i24_1);
      this_1.j1f().b1h(this_1);
      $this$append.d1h();
      // Inline function 'kotlinx.html.div' call
      var classes_1 = $classNames.n24_1;
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_2 = new DIV(attributesMapOf('class', classes_1), $this$append);
      if (!(this_2.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_2.j1f().a1h(this_2);
      // Inline function 'kotlinx.html.label' call
      var classes_2 = $classNames.o24_1;
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_3 = new LABEL(attributesMapOf('class', classes_2), this_2.j1f());
      this_3.j1f().a1h(this_3);
      this_3.n1f($labels.f24_1);
      // Inline function 'kotlinx.html.select' call
      var classes_3 = $classNames.p24_1;
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_4 = new SELECT(attributesMapOf('class', classes_3), this_3.j1f());
      this_4.j1f().a1h(this_4);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $paymentMethodOptions.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.option' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_5 = new OPTION(attributesMapOf('class', null), this_4.j1f());
        this_5.j1f().a1h(this_5);
        this_5.d1m(element.j24_1);
        this_5.n1f(element.k24_1);
        this_5.j1f().b1h(this_5);
      }
      this_4.j1f().b1h(this_4);
      this_3.j1f().b1h(this_3);
      // Inline function 'kotlinx.html.label' call
      var classes_4 = $classNames.o24_1;
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_6 = new LABEL(attributesMapOf('class', classes_4), this_2.j1f());
      this_6.j1f().a1h(this_6);
      this_6.n1f($labels.g24_1);
      var tmp2 = InputType_number_getInstance();
      // Inline function 'kotlinx.html.input' call
      var classes_5 = $classNames.q24_1;
      var tmp = tmp2 == null ? null : enumEncode(tmp2);
      var tmp_0 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_7 = new INPUT(attributesMapOf_0(['type', tmp, 'formenctype', tmp_0, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', classes_5]), this_6.j1f());
      this_7.j1f().a1h(this_7);
      // Inline function 'kotlin.collections.set' call
      this_7.l1f().m2('min', '1');
      // Inline function 'kotlin.collections.set' call
      this_7.l1f().m2('step', '1');
      this_7.j1f().b1h(this_7);
      this_6.j1f().b1h(this_6);
      // Inline function 'kotlinx.html.button' call
      var classes_6 = $classNames.r24_1;
      var tmp_1 = null == null ? null : enumEncode(null);
      var tmp_2 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_8 = new BUTTON(attributesMapOf_0(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_6]), this_2.j1f());
      this_8.j1f().a1h(this_8);
      this_8.z1j(ButtonType_button_getInstance());
      set_onClickFunction(this_8, renderWallet$lambda$lambda($container, $classNames, $onTopUp));
      this_8.n1f($labels.h24_1);
      this_8.j1f().b1h(this_8);
      this_2.j1f().b1h(this_2);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = TopUpPaymentMethodOption;
  _.$_$.b = WalletLabels;
  _.$_$.c = renderWallet;
  //endregion
  return _;
}));

